import { render, staticRenderFns } from "./searchTotal.vue?vue&type=template&id=641f8219&scoped=true"
import script from "./searchTotal.vue?vue&type=script&lang=js"
export * from "./searchTotal.vue?vue&type=script&lang=js"
import style0 from "./searchTotal.vue?vue&type=style&index=0&id=641f8219&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f8219",
  null
  
)

export default component.exports